const icons = {
  error: 'exclamation-triangle',
  warning: 'exclamation-triangle',
  info: 'info-circle',
  success: 'check-circle',
};

const ToastMessage = ({iconStyle, message}) => (
  <div>
    <i aria-hidden="true" className={`fa fa-${icons[iconStyle]}`}/>
    <span className="error-message">
      {message}
    </span>
  </div>
);

export default ToastMessage;
